import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../../../baseurl";
import moment from "moment";
import { Button, Row, Col } from "reactstrap";

const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");
const username = localStorage.getItem("username");
const companyName = localStorage.getItem("companyName");

const PrintMeatProcessing = (props) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const recordId = props?.location?.state?.id;
    if (recordId) {
      fetchData(recordId);
    } else {
      setLoading(false);
    }
  }, [props?.location?.state?.id]);

  const fetchData = async (id) => {
    try {
      const res = await axios.post(
        `${baseurl}/pointofsale/getMeatProcById`,
        { companyId, username, id },
        { headers: { authorization: token } },
      );
      setData(res.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching print data:", err);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-5 text-center">
        <div className="spinner-border text-dark mr-3" role="status"></div>
        <h4>Preparing Meat Processing Report...</h4>
      </div>
    );
  }

  if (!data || !data.master) {
    return (
      <div className="p-5 text-center border mt-5">
        <h4 className="text-dark font-weight-bold">RECORD NOT FOUND</h4>
        <p>Could not retrieve data for the selected processing record.</p>
        <Button color="dark" onClick={() => props.history.goBack()}>
          Go Back
        </Button>
      </div>
    );
  }

  const { master, detail } = data;

  return (
    <div
      className="print-container bg-white"
      style={{
        minHeight: "100vh",
        padding: "30px",
        color: "#000",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Print Controls */}
      <div className="d-print-none mb-5 d-flex justify-content-between align-items-center no-print">
        <Button
          color="secondary"
          outline
          onClick={() => props.history.goBack()}
          style={{ borderRadius: "0" }}
        >
          <i className="fa fa-arrow-left mr-2" /> Back
        </Button>
        <Button
          color="dark"
          onClick={() => window.print()}
          style={{ borderRadius: "0", padding: "10px 40px" }}
        >
          <i className="fa fa-print mr-2" /> Print Report
        </Button>
      </div>

      {/* Corporate Header Section */}
      <div className="text-center mb-4 border-bottom border-dark pb-3">
        <h2 className="font-weight-bold mb-1" style={{ letterSpacing: "2px" }}>
          {companyName?.toUpperCase()}
        </h2>
        <div style={{ fontSize: "12px", marginTop: "5px" }}>
          Report Date: {moment().format("DD-MMM-YYYY")}
        </div>
      </div>

      <div
        className="text-center mb-5 mt-2 bg-dark text-white p-2"
        style={{ border: "2px solid #000" }}
      >
        <h4 className="mb-0 font-weight-bold" style={{ letterSpacing: "4px" }}>
          MEAT PROCESSING VOUCHER
        </h4>
      </div>

      {/* Metadata Section - Block Layout */}
      <Row className="mb-4 no-gutters">
        <Col xs="7" className="pr-2">
          <div
            style={{
              border: "2.5px solid #000",
              padding: "15px",
              minHeight: "130px",
            }}
          >
            <h6
              className="font-weight-bold mb-3 border-bottom border-dark pb-1"
              style={{ textDecoration: "underline" }}
            >
              BRANCH INFORMATION:
            </h6>
            <div style={{ fontSize: "15px" }}>
              <div>
                <strong>Branch Name:</strong> {master.branch_name}
              </div>
              <div className="mt-2">
                <strong>Location:</strong> {"Head Office / Store"}
              </div>
              {/* <div className="mt-2">
                <strong>Processing Item:</strong>{" "}
                {master.item_name || master.item_desc}
              </div> */}
            </div>
          </div>
        </Col>
        <Col xs="5" className="pl-2">
          <div
            style={{
              border: "2.5px solid #000",
              padding: "15px",
              minHeight: "130px",
            }}
          >
            <h6
              className="font-weight-bold mb-3 border-bottom border-dark pb-1"
              style={{ textDecoration: "underline" }}
            >
              VOUCHER:
            </h6>
            <div style={{ fontSize: "15px" }}>
              <div className="d-flex justify-content-between">
                <strong>Voucher No:</strong> <span>{master.doc_no}</span>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <strong>Date:</strong>{" "}
                <span>{moment(master.proc_date).format("DD-MMM-YYYY")}</span>
              </div>
              {/* <div className="d-flex justify-content-between mt-2">
                <strong>Item Code:</strong> <span>{master.item_id}</span>
              </div> */}
            </div>
          </div>
        </Col>
      </Row>

      {/* Processing Item Overview Section */}
      <div
        className="mb-4"
        style={{ border: "2.5px solid #000", padding: "15px" }}
      >
        <h6 className="font-weight-bold mb-3 border-bottom border-dark pb-1">
          MEAT PROCESSING ITEM:
        </h6>
        <Row className="text-center">
          <Col xs="3" style={{ borderRight: "1px solid #000" }}>
            <div className="small font-weight-bold text-uppercase">
              Material Name
            </div>
            <div className="h5 font-weight-bold">{master.item_desc}</div>
          </Col>
          <Col xs="3" style={{ borderRight: "1px solid #000" }}>
            <div className="small font-weight-bold text-uppercase">
              Total Weight Intake
            </div>
            <div className="h4 font-weight-bold">
              {parseFloat(master.weight || 0).toLocaleString()} <small>Kgs</small>
            </div>
          </Col>
          <Col xs="3" style={{ borderRight: "1px solid #000" }}>
            <div className="small font-weight-bold text-uppercase">
              Rate / Kg
            </div>
            <div className="h4 font-weight-bold">
              {/* The document rate is not stored -- it is derived as
                  amount / weight, exactly as the entry form derives it.
                  Printing last_avg_rate here showed the reconciliation
                  average instead of the rate the voucher was priced at. */}
              {(parseFloat(master.weight) > 0
                ? parseFloat(master.amount || 0) / parseFloat(master.weight)
                : 0
              ).toLocaleString(undefined, {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}
            </div>
            <div style={{ fontSize: "10px", fontStyle: "italic" }}>
              avg at processing:{' '}
              {parseFloat(master.last_avg_rate || 0).toLocaleString(undefined, {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}
            </div>
          </Col>
          <Col xs="3">
            <div className="small font-weight-bold text-uppercase">
              Total Valuation
            </div>
            <div className="h5 font-weight-bold">
              {parseFloat(master.amount || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })}
            </div>
          </Col>
        </Row>
        <div
          className="text-center mt-2 pt-2"
          style={{ borderTop: "1px solid #000", fontSize: "11px" }}
        >
          Valuation = Total Weight Intake &times; Rate / Kg
        </div>
      </div>

      {/* Main Detail Table - Block Mono Style */}
      <div className="table-container mb-4">
        <table
          className="table table-bordered border-dark text-center"
          style={{
            border: "2.5px solid #000",
            width: "100%",
            tableLayout: "fixed",
          }}
        >
          <thead
            style={{
              backgroundColor: "#000",
              color: "#fff",
              WebkitPrintColorAdjust: "exact",
              printColorAdjust: "exact",
            }}
          >
            <tr>
              <th style={{ border: "1px solid #fff", width: "50px" }}>#</th>
              <th
                style={{
                  border: "1px solid #fff",
                  textAlign: "left",
                  width: "35%",
                }}
              >
                Description
              </th>
              <th style={{ border: "1px solid #fff" }}>Qty</th>
              <th style={{ border: "1px solid #fff" }}>Weight (Kg)</th>
              <th style={{ border: "1px solid #fff" }}>Yield (%)</th>
              <th style={{ border: "1px solid #fff" }}>Rate/Kg</th>
              <th style={{ border: "1px solid #fff" }}>Rate/Pc</th>
              <th
                style={{
                  border: "1px solid #fff",
                  textAlign: "right",
                  paddingRight: "10px",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "14px" }}>
            {detail && detail.length > 0 ? (
              detail.map((row, index) => {
                const rowQty = parseFloat(row.quantity) || 0;
                const rowKgs = parseFloat(row.kgs) || 0;
                const rowAmt = parseFloat(row.amount) || 0;
                
                const ratePerKg = rowKgs > 0 ? rowAmt / rowKgs : 0;
                const ratePerPc = rowQty > 0 ? (rowAmt / rowQty) : 0;

                return (
                  <tr key={index}>
                    <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                    <td
                      style={{
                        border: "1px solid #000",
                        textAlign: "left",
                        fontWeight: "bold",
                      }}
                    >
                      {row.item_desc}
                    </td>
                    <td style={{ border: "1px solid #000", textAlign: "right" }}>
                      {rowQty.toLocaleString()}
                    </td>
                    <td style={{ border: "1px solid #000", textAlign: "right" }}>
                      {rowKgs.toFixed(3)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        fontWeight: "bold",
                        textAlign: "right",
                      }}
                    >
                      {parseFloat(row.percentage || 0).toFixed(2)}%
                    </td>
                    <td style={{ border: "1px solid #000", textAlign: "right" }}>
                      {ratePerKg.toFixed(2)}
                    </td>
                    <td style={{ border: "1px solid #000", textAlign: "right" }}>
                      {ratePerPc.toFixed(3)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        textAlign: "right",
                        paddingRight: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      {rowAmt.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="p-4">
                  No breakdown detail available
                </td>
              </tr>
            )}
          </tbody>
          <tfoot
            className="font-weight-bold"
            style={{ backgroundColor: "#fff", border: "2px solid #000" }}
          >
            <tr style={{ borderTop: "2.5px solid #000", textAlign: "right" }}>
              <td colSpan="2" className="text-right py-2">
                TOTALS:
              </td>
              <td className="py-2" style={{ textAlign: "right" }}>
                {detail?.reduce((sum, r) => sum + (parseFloat(r.quantity) || 0), 0).toLocaleString()}
              </td>
              <td className="py-2" style={{ textAlign: "right" }}>
                {detail?.reduce((sum, r) => sum + (parseFloat(r.kgs) || 0), 0).toFixed(2)}
              </td>
              <td className="py-2" style={{ textAlign: "right" }}>
                {detail?.reduce((sum, r) => sum + (parseFloat(r.percentage) || 0), 0).toFixed(2)}%
              </td>
              <td></td>
              <td></td>
              <td
                className="text-right pr-2 py-2"
                style={{ textAlign: "right" }}
              >
                {detail?.reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Footer Section - Remarks and Signature */}
      <div className="mt-4 border-top border-dark pt-3">
        <div
          style={{
            border: "2px solid #000",
            padding: "10px",
            backgroundColor: "#fff",
            marginBottom: "30px",
          }}
        >
          <strong>REMARKS:</strong>
          <p
            className="mb-0 mt-1"
            style={{ fontSize: "14px", fontStyle: "italic" }}
          >
            {master.remarks || "No additional comments."}
          </p>
        </div>
      </div>

      {/* <style>{`
        @media print {
            
            @page {
                size: A4;
                margin: 0 !important;
                padding: 0 !important;
            }
          
          .print-container {
            border: none !important;
            min-height: auto !important;
            max-width: 100% !important;
            overflow: visible !important;
            background-color: white !important;
          }
          
          .no-print, .d-print-none {
            display: none !important;
          }
          
          .table { 
            border-collapse: collapse !important;
            page-break-inside: auto !important;
          }
          
          .table tr {
            page-break-inside: avoid !important;
            page-break-after: auto !important;
          }
          
          .table-bordered th, .table-bordered td {
            border: 1px solid #000 !important;
          }
          
          thead {
            display: table-header-group !important;
          }

          thead th {
            background-color: #000 !important;
            color: #fff !important;
            -webkit-print-color-adjust: exact !important; 
            print-color-adjust: exact !important;
          }
          
          tfoot {
            display: table-footer-group !important;
            background-color: #fff !important;
            border: 2px solid #000 !important;
          }
          
          .bg-dark { 
            background-color: #000 !important; 
            color: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .bg-white { 
            background-color: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .text-white { 
            color: #fff !important; 
          }
          
          .mb-5, .mt-5 {
            margin-bottom: 1rem !important;
            margin-top: 1rem !important;
          }
          
          .mb-4, .mt-4 {
            margin-bottom: 0.75rem !important;
            margin-top: 0.75rem !important;
          }
        }
      `}</style> */}
      <style>{`
        @media print {

            @page {
                size: A4;
                margin: 0 !important;
                padding: 0 !important;
            }

          /*
           * Other print pages in this app (inventory transfer, sticker,
           * payment prints, etc.) ship global, unscoped "@media print" rules
           * targeting html/body. Their CSS is injected into <head> when those
           * routes are visited and is never removed for the rest of the SPA
           * session, so it bleeds onto this page and breaks its layout until a
           * full refresh clears it. Re-assert a neutral html/body here so this
           * voucher renders identically no matter what was visited before.
           */
          html, body {
            display: block !important;
            width: auto !important;
            height: auto !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            align-items: initial !important;
            justify-content: initial !important;
            background: #fff !important;
          }

          .print-container {
            border: none !important;
            min-height: auto !important;
            max-width: 100% !important;
            overflow: visible !important;
            background-color: white !important;
          }
          
          .no-print, .d-print-none {
            display: none !important;
          }
          
          .table { 
            border-collapse: collapse !important;
            page-break-inside: auto !important;
          }
          
          .table tr {
            page-break-inside: avoid !important;
            page-break-after: auto !important;
          }
          
          .table-bordered th, .table-bordered td {
            border: 1px solid #000 !important;
          }
          
          thead {
            display: table-header-group !important;
          }

          table.table thead th, 
          .table-bordered thead th {
            background-color: #000 !important;
            color: #fff !important;
            -webkit-print-color-adjust: exact !important; 
            print-color-adjust: exact !important;
            border: 1px solid #fff !important;
          }
          
          tfoot {
            display: table-footer-group !important;
            background-color: #fff !important;
            border: 2px solid #000 !important;
          }
          
          .bg-dark { 
            background-color: #000 !important; 
            color: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .bg-white { 
            background-color: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .text-white { 
            color: #fff !important; 
          }
          
          .mb-5, .mt-5 {
            margin-bottom: 1rem !important;
            margin-top: 1rem !important;
          }
          
          .mb-4, .mt-4 {
            margin-bottom: 0.75rem !important;
            margin-top: 0.75rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PrintMeatProcessing;